export default __webpack_public_path__ + "static/media/Outfit-VariableFont_wght.7d17abd5.ttf";